export default __webpack_public_path__ + "static/media/juego5_perder.da893ae1.png";